import classNames from 'classnames';
import React from 'react';

import { useDisplayCustomWallpaper } from '@wetransfer/transfer/component/TransferCustomizationProvider/hooks';
import { useAppSelector } from '@wetransfer/transfer/hooks';
import Router from '@wetransfer/transfer/modules/router';
import { selectIsCustomWallpaperBeingFetched } from '@wetransfer/transfer/store/customWallpapers';
import { ErrorBoundary } from '@wetransfer/transfer/wallpaper-bundle/error-boundary';

import { connector } from './connector';
import AdSDKMicroFrontend from './micro-frontend';
import TransferWallpaperContainer from './TransferWallpaperContainer';

import './styles.scss';

export const AdSDKContainer: React.FC<any> = ({
  state,
  channelWallpapers = [],
}) => {
  const { dropzoneActive } = state.layout;
  const { isPanelOpen, isPanelHalfOpen, isPanelFullOpen, params } = state.route;
  const demoAdvertId = params?.advert_id;

  const customWallpaper = useDisplayCustomWallpaper();

  const wallpaperClassNames = React.useCallback(() => {
    return classNames('wallpaper', {
      'wallpaper--no-transition': !isPanelOpen,
      'wallpaper--half-panel': isPanelHalfOpen,
      'wallpaper--full-panel': isPanelFullOpen,
      'wallpaper--behind-dropzone': dropzoneActive,
    });
  }, [isPanelOpen, isPanelHalfOpen, isPanelFullOpen, dropzoneActive]);

  const isCustomWallpaperBeingFetched = useAppSelector(
    selectIsCustomWallpaperBeingFetched
  );

  const renderWallpaperContainer = () => {
    if (isCustomWallpaperBeingFetched) {
      return null;
    }

    if ((customWallpaper || channelWallpapers.length) && !demoAdvertId) {
      return (
        <TransferWallpaperContainer
          wallpapers={customWallpaper ? [customWallpaper] : channelWallpapers}
        />
      );
    }

    return <AdSDKMicroFrontend />;
  };

  const renderBlockingLayer = () => {
    if (!isPanelOpen) return null;

    return (
      <div
        className="wallpaper__blocking-layer"
        onClick={() => Router.navigateTo(Router.getLastRoute('transfer', '/'))}
        onKeyDown={() =>
          Router.navigateTo(Router.getLastRoute('transfer', '/'))
        }
        tabIndex={-1}
        data-testid="blocking-layer"
        role="button"
      />
    );
  };

  return (
    <ErrorBoundary>
      <div
        id="wallpaper-container"
        data-testid="wallpaper-container"
        className={wallpaperClassNames()}
      >
        {renderBlockingLayer()}
        {renderWallpaperContainer()}
      </div>
    </ErrorBoundary>
  );
};

export default connector(AdSDKContainer);
